module.exports = {"private":true,"main":"./TextArea.js"}


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/fields/TextArea/package.json
// module id = 838
// module chunks = 0 1